module.exports = __webpack_public_path__ + "img/45.3d2f5329.png";